export const locale = {
    lang: 'tr',
    data: {
      'LOGIN': {
        'AUTENTICACION': {
          'TITULO': 'İki adımlı kimlik doğrulama',
          'SUBTITULO': 'Platforma girerken daha fazla güvenlik sağlamak için aşağıda belirtildiği gibi iki aşamalı kimlik doğrulaması yapmanız gerekir.',
          'BOTONES': {
            'SIGUIENTE': 'Sonraki',
            'ANTERIOR': 'Önceki'
          },
          'PASOS': {
            '1': {
              'TITULO': 'Aşama 1',
              'INSTRUCCION': 'QR kodunu Google Authenticator mobil uygulamasıyla tarayın ve sonraki düğmesine tıklayın',
              'REGISTRADO': 'E-postanızın Google Authenticator uygulamasında kayıtlı olduğu tespit edildi, QR kodunu tekrar taramanıza gerek yok, bir sonraki adıma geçin'
            },
            '2': {
              'TITULO': 'Adım 2',
              'INSTRUCCION': 'Google Authenticator tarafından sağlanan anahtarı girin ve ileri\'yi tıklayın. ',
              'INPUT': 'Anahtar alındı',
              'INFOPREVIA': {
                'INFO_1': 'Bu bilgisayardan platforma zaten eriştiğiniz tespit edildi. QR kodunu tekrar taramanıza gerek yok',
                'INFO_2': 'Hesabınız için Google Authenticator tarafından sağlanan şifreyi girin ve ileri\'yi tıklayın.',
                'INFO_3': 'QR kodunu tekrar taramak istiyorsanız, Önceki düğmesine tıklayın.',
                'INFO_4': 'Uyarı: Bunu yaparak hesabınızı tekrar Google Authenticator\'a bağlamanız gerekecek',
              }
            },
            '3': {
              'TITULO': 'Sonuç',
              'INSTRUCCION': 'Bir önceki adımda QR kodundan aldığınız anahtarı girin ve ileri butonuna tıklayın.',
              'VALIDANDO': 'Girilen anahtar doğrulanıyor, bir dakika bekleyin',
              'MAL': 'Anahtar yanlış veya süresi dolmuş, lütfen anahtarı tekrar girin ve tekrar deneyin',
              'BIEN': 'Kimlik doğrulamayı başarıyla tamamladınız, ardından platforma gireceksiniz'
            },
          }
        },
        'PASSWORD':{
          'AVISO':'Lütfen e-posta adresinizi girin, şifrenizi değiştirmek için size bir bağlantı göndereceğiz',
          'BTN':'Eposta gönder',
          'PLACERHOLDER':'e-mail adresleri',
          'ERROR':'E-postanızı bulamadık. Lütfen farklı bir e-posta deneyin',
          'TRUE':'E-posta gönderildi, lütfen spam klasörü yerine gelen kutunuzu kontrol edin'
        },
        'RESET':{
          'LABEL01':'Şifre uyuşmuyor   ',
          'LABEL02':'Parola',
          'LABEL03':'Şifrenizi yeniden yazın',
          'BTN':'Change password',
          'ERROR':'Hata, jeton bulunamadı',
          'NOPASSWORDMATCH':'Şifre uyuşmuyor',
          'CARACTERES':'En az 3 karakter olmalı',
          'SUCCESSCHANGE':'Şifreniz doğru şekilde değiştirildi'
        },
        'LANDING': {
          'MENSAJE': 'Hoşgeldiniz',
          'NAVEG': 'CulturalGO platformu için önerilen tarayıcı <a class="linkChrome" href="https://www.google.com/intl/es-419/chrome/" target="blank">Google Chrome</a>'
        },
        'MODALES': {
          'AVISO1': {
            'TITULO': 'Önemli Duyuru.',
            'TEXTO': `Sevgili Kullanıcı:<br><br>
            Daha iyi bir hizmet sunabilmek için, çalışmasını optimize etmek amacıyla Cultural GO platformunda bir güncelleme yapılacağı konusunda bilgilendirilirsiniz.<br><br>
            Güncelleme <strong>23 Temmuz Cuma günü saat 23:59'dan itibaren gerçekleşecek. 24 Temmuz Cumartesi günü saat 23:59'a kadar</strong>. Bu süre zarfında platform devre dışı kalacaktır. Ancak, mevcut anketler aktif kalacaktır.<br><br>
            Anlayışınız için minnettarız.`
          }
        },
        'FORM': {
          'FORGOTPASSWORD':'Şifre kurtarma',
          'LOGIN':'HESABINIZA GİRİŞ YAPIN',
          'TITULO': 'HESABINIZA GİRİŞ YAPIN',
          'INPUT':{
            'EMAIL': 'E-mail',
            'PASSWORD': 'Şifre',
            'LANGSEL': 'Dil seçimi'
          },
          'VAL': {
            'NOTEMAIL': 'Email gerekiyor ',
            'INVEMAIL': 'Lütfen geçerli bir e-mail adresi girin ',
            'CARACT_EMA': ' Alan şu karakterlere izin vermiyor /&¿+#$%([=])*?"<>:\'',
            // 'PASS': ' Şifre gerekiyor ',
            'PASS': 'Geçersiz şifre',
          },
          'SIGNIN': 'GO!',
          'CAMBIALOGO': 'Şirket logonuzu değiştirmek için buraya tıklayın',
          'CARGAOK': 'Şirket logonuz doğru yüklenmiş',
          'CARGANULL': 'Şirket logonuz yüklenirken bir hata oluştu',
          'CARGAERROR': 'Seçilen dosyanın formatı doğru değil. Sadece biçimler kabul edilir: jpg, png, gif'
        }
      },
      'LOGIN-ENCUESTADOR':{
        'FORM': {
          'TITULO': 'INGRESE A SU CUENTA',
          'INPUT':{
            'PASSWORD': 'Parola:',
            'LANGSEL': 'Bir dil seçin:',
            'LOGIN':'Oturum aç',
          },

      },
      'INTRO-LOGIN':{
        'TITULO': 'TALİMATLAR',
        'TEXT1': 'Work® Institute için Harika Bir Yer. çalışma ortamı anketinize% 100 gizli cevap vermenizi memnuniyetle karşılar ',
        'TEXT2': 'Gizlilik',
        'TEXT3': 'Enstitüde:',
        'TEXT4': 'yanıtları kuruluş ve bölgeye göre yönetir, işler, istatistiksel olarak analiz ederiz.',
        'TEXT5': 'Örgütlerin iklimindeki iyileştirme eylemlerini gösteren küresel sonuçlar üretiyoruz.',
        'TEXT6': 'bireysel yanıtları bilmiyorsunuz',
        'TEXT7': 'Bireysel yanıtlar kesinlikle gizlidir',
        'TEXT8': 'Şikayet ve Öneriler',
        'TEXT9': 'Kesinlikle yasaktır:',
        'TEXT10': 'ankete özgürce cevap vermekten etkileniyor, cezalandırılıyor veya engelleniyorsunuz.',
        'TEXT11': 'Şikayet veya öneri yapmak için aşağıdaki e-postayı elimize sunuyoruz:',
        'TEXT12': 'mx_transparencia@greatplacetowork.com',
        'TEXT13': 'Talimatlar:',
        'TEXT14': '1. Girin ',
        'TEXT15': 'çalışan sayısı + doğum yılı',
        'TEXT16': '2. Boş alan bırakmayın. ',
        'TEXT17': '3. Başlatı tıklayın. ',
        'TEXT18': 'Great Place to Work® Enstitüsü anketine cevap vermemize yardımcı olun!',
      }

    },
    'LOADING':{
      'TEXT_WELCOM':' CulturalGo ya Hoş Geldiniz',
      'TEXT_CHANGE':'Bilgiler yükleniyor...',
    }
    }
};
